import React, { useCallback, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NumberInput from '@rd-web-markets/shared/dist/util/form_fields/NumberInput';
import IsNotSaved from '../IsNotSaved';
import YesOrNoFormField from '@rd-web-markets/shared/dist/util/form_fields/YesOrNoFormField';
import useUpdateState from '../hooks/useUpdateState';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import AffiliateCompaniesSection from './AffiliateCompaniesSection';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
const Affiliates = _ref => {
  let {
    affiliates,
    setAffiliates,
    financialYear,
    elsterId
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isNotSaved, setIsNotSaved] = useState(false);
  const [updateState] = useUpdateState(setAffiliates, setIsNotSaved);
  const saveData = useErrorHandling(useCallback(async body => {
    if (body.max_eligible_base_to_be_taken_into_account_for_request < 0) {
      throw new Error('Values must be greater than 0');
    }
    const response = await generalRouteSubRouteService.update(body.elster_id, 'elsters', 'affiliate', '', body);
    setAffiliates({
      ...response
    });
    setIsNotSaved(false);
  }, [setAffiliates]));
  const renderInput = (field, index, type) => {
    if (type === 'decimal') {
      return /*#__PURE__*/React.createElement(ChangeHighlighter, {
        as: FormattedNumberInput,
        thousandSeparator: ".",
        decimalSeparator: ",",
        object: field,
        name: 1,
        type: "text",
        size: "sm",
        onlyPositiveNumbers: true,
        onChange: e => updateState({
          target: {
            value: e.target.value
          }
        }, affiliates, field[0]),
        style: {
          width: '100px'
        }
      });
    } else if (type === 'boolean') {
      return /*#__PURE__*/React.createElement("div", {
        key: field[0] + 'affiliateYesOrNo'
      }, /*#__PURE__*/React.createElement(YesOrNoFormField, {
        labelText: t(field[0]),
        formName: 'affiliate' + index,
        checkedField: field[1],
        onChange: updateState,
        onChangeParams: [affiliates, field[0]]
      }));
    }
  };
  const affiliateRows = Object.entries(affiliates).map((af, index) => {
    if (['id', 'elster_id', 'created_at', 'updated_at'].includes(af[0])) return null;
    if (af[1] === true || af[1] === false) {
      return renderInput(af, index, 'boolean');
    } else {
      return /*#__PURE__*/React.createElement(Row, {
        key: af[0] + 'decimal_row'
      }, /*#__PURE__*/React.createElement(Col, {
        md: 7
      }, /*#__PURE__*/React.createElement("p", null, t(af[0]))), /*#__PURE__*/React.createElement(Col, {
        md: 1
      }, renderInput(af, index, 'decimal')));
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Col, null, t('information_on_the_distribution_of_the_maximum_eligible_tax_base_for_associated_enterprises')), /*#__PURE__*/React.createElement(Col, null)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('financial_year')), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, financialYear)), /*#__PURE__*/React.createElement("hr", null), affiliateRows, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(AffiliateCompaniesSection, {
    elsterId: elsterId
  }), /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [affiliates]
  }));
};
export default Affiliates;